<h1 class="title">Standardnamn</h1>
<p class="brodtext-medium-14">
  Ett standardnamn är det namn som Svebargruppen beslutat att använda för respektive smittämne, analys, provtyp eller <br>
  antibiotika. I största möjliga mån används nationell och internationell nomenklatur så som SnomedCT ... Negativa fynd <br>
  är alla analyser som svarats ut som negativa eller bedömts som negativa av det kliniskt mikrobiologiska laboratoriet. <br>
  Beskrivande fynd är en samling av analyssvar som till exempel har växt av annat än det smittämne man förväntat sig  <br>
  såsom blandflora.
</p>
<app-button-set [buttons]="standardNamnTypesButtonSet" (select)="onSelect($event)"></app-button-set>
<app-table [config]="tableConfig"></app-table>
